<style lang="scss" scoped>
.slide-7 {
  background-image: url(../../../assets/module5/slide7/bg-01.jpg);
  background-size: cover;
  background-position: center;
  padding-top: 100px;
  height: calc(100% - 100px);
  padding-right: 70px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
h1 {
  color: white;
  font-size: 117px;
  margin-right: 300px;
}
.content {
  width: 651px;
  margin-right: 100px;
}
p {
  color: white;
}
h2 {
  color: #aa252c;
  margin-top: 10px;
  font-size: 70px;
}
</style>

<template>
  <div class="slide-7">
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 6"
        src="@/assets/module5/slide7/2_img-01.png"
        class="chars"
      />
    </transition>

    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 6"
        src="@/assets/module5/slide7/sophia-01.png"
        class="chars delay-1"
      />
    </transition>

    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 6"
        src="@/assets/module5/slide7/photo-01.png"
        class="chars delay-2"
      />
    </transition>

    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 6"
        src="@/assets/module5/slide7/timmy-01.png"
        class="chars"
      />
    </transition>

    <transition name="scale" appear>
      <h1 v-show="slideIndex == 6" class="delay-3">Sophia’s</h1>
    </transition>

    <transition name="scale" appear>
      <div v-show="slideIndex == 6" class="content delay-4">
        <p>superpower is her very</p>
        <h2>powerful voice</h2>
        <p>
          that tells wonderful stories but if the Evil Clot attacks Sophia, she
          will suddenly not be able to speak properly and her lips won’t work.
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
